import {
  ApplicationConfig,
  provideAppInitializer,
  inject,
  provideBrowserGlobalErrorListeners,
  importProvidersFrom,
} from '@angular/core';
import { AuthService } from './services/auth.service';
import {
  TranslateLoader,
  TranslateModule,
  TranslationObject,
} from '@ngx-translate/core';
import { firstValueFrom, Observable } from 'rxjs';

class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`/assets/i18n/${lang}.json`);
  }
}
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { ShamDashboardData } from 'sham-components/features/dashboard';
import { dashboardLayoutDataFactory } from './services/dashboardDataFactory';
import { authInterceptor } from './services/auth.interceptor';
import { errorInterceptor } from './services/error.interceptor';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { appEnvFactory } from '@/app/services/appEnvFactory';
import { AppEnvironment } from 'sham-components/services';

export function httpLoaderFactory(http: HttpClient) {
  return new CustomTranslateLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    // SellerSignupManager,
    // provideSignalrNotifications({
    //   hubUrl: `${API_BASE_URL}/hubs/notifications`,
    //   accessTokenFactory: () =>
    //     globalThis.sessionStorage?.getItem('accessToken') ?? '',
    //   notificationEventNames: ['NotificationReceived'],
    //   enableAutomaticReconnect: true,
    // }),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideAppInitializer(() => {
      const appEnvService = inject(AppEnvironment);
      const authService = inject(AuthService);
      const dashboardService = inject(ShamDashboardData);

      return appEnvFactory(appEnvService).then(() =>
        Promise.allSettled([
          firstValueFrom(authService.processRefreshVerification()),
          dashboardLayoutDataFactory(dashboardService),
        ]),
      );
    }),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
  ],
};
